import { CheckboxProps as MuiCheckboxProps } from '@mui/material';

export enum CheckboxVariantEnum {
  primary = 'primary',
  secondary = 'secondary'
}

export type CheckboxVariants = keyof typeof CheckboxVariantEnum;

export interface CheckboxProps extends MuiCheckboxProps {
  variant?: CheckboxVariants;
  label?: string;
}

export type LabelProps = {
  disabled: boolean;
};

export type CheckboxIconProps = {
  borderColor: string;
};
